document.addEventListener('DOMContentLoaded',()=>{

  const stickyHeader=document.querySelector('[data-sticky-header]');
  if(stickyHeader){
    const syncHeaderHeight=()=>document.documentElement.style.setProperty('--veroula-header-height',`${stickyHeader.offsetHeight}px`);
    const syncHeaderState=()=>stickyHeader.classList.toggle('is-scrolled',window.scrollY>8);
    syncHeaderHeight();
    syncHeaderState();
    window.addEventListener('resize',syncHeaderHeight,{passive:true});
    window.addEventListener('scroll',syncHeaderState,{passive:true});
  }
  const obs=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting)e.target.classList.add('is-visible')}),{threshold:.12});
  document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));
  document.querySelectorAll('[data-qty]').forEach(w=>{const i=w.querySelector('input');w.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{const n=Math.max(1,(parseInt(i.value)||1)+(b.dataset.action==='plus'?1:-1));i.value=n}))});
  const toggle=document.querySelector('.mobile-nav-toggle');
  const nav=document.querySelector('#PrimaryNavigation');
  if(toggle&&nav){
    toggle.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close menu':'Open menu');});
    nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label','Open menu');}));
  }
  document.querySelectorAll('[data-variant-select]').forEach(select=>{
    select.addEventListener('change',()=>{
      const option=select.options[select.selectedIndex];
      const price=document.querySelector('[data-product-price]');
      const compare=document.querySelector('[data-compare-price]');
      if(price&&option.dataset.price) price.textContent=option.dataset.price;
      if(compare) compare.textContent=option.dataset.compare||'';
    });
  });
  document.querySelectorAll('[data-scroll-to-product]').forEach(button=>button.addEventListener('click',()=>{
    const form=document.querySelector('#VeroulaProductForm');
    if(form) form.scrollIntoView({behavior:'smooth',block:'center'});
  }));
});
